import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ChatApp from "./app";          // existing chat UI
import FormApp from "./plain_form";   // NEW – form-only UI
import StudyApp from "./study/StudyApp"; // approval-granularity study UIs

const path = window.location.pathname;
const Root = path.startsWith("/study/") ? StudyApp
           : path.startsWith("/form/") ? FormApp
           : ChatApp;

ReactDOM.createRoot(document.getElementById("root")).render(<Root />);
